import curd from '../curd'
import {qs} from '../qs'

const BASE_PATH = 'audit/month'

export default curd(BASE_PATH, {
  getSiteDeviceAuditDailies: (query) => ({
    url: `${BASE_PATH}/info${qs(query, '?')}`,
    method: 'GET'
  }),
  getAuditDataList: (siteDeviceId, query) => ({
    url: `${BASE_PATH}/DATA/LIST/${siteDeviceId}${qs(query, '?')}`,
    method: 'GET'
  })
  // syncCloud: () => ({
  //   url: `${BASE_PATH}/cloud/information`,
  //   method: 'GET'
  // }),
  // getSiteState: query => ({
  //   url: `${BASE_PATH}/online/condition`,
  //   method: 'POST',
  //   data: query
  // })
})



// WEBPACK FOOTER //
// ./src/apis/modules/MonthlyAudit.js